import { gsap } from 'gsap';
import { setScrolled } from "../../helpers/events";

export default () => {

	const header = document.querySelector('.js-header');
	if (!header) return;

	const burger = header.querySelector('.js-burger');
	const close = header.querySelector('.js-burger-close');

	let prevScroll = window.pageYOffset;

	setScrolled(() => {
		if (window.pageYOffset > 100) {
			header.classList.add('scrolled');

			if (window.pageYOffset > prevScroll) {
				gsap.to(header, {
					y: '-100%',
					duration: 0.4
				});
			}
			else {
				gsap.to(header, {
					y: 0,
					duration: 0.4
				});
			}
		}
		else {
			header.classList.remove('scrolled');
		}

		prevScroll = window.pageYOffset;
	});

	burger.addEventListener('click', () => {
		header.classList.add('header--opening-mob');
		setTimeout(() => {
			header.classList.add('header--open-mob');
		}, 400);
	});

	close.addEventListener('click', () => {
		header.classList.remove('header--open-mob');
		setTimeout(() => {
			header.classList.remove('header--opening-mob');
		}, 10);
	});
};

export function resetHeader() {

	const header = document.querySelector('.js-header');
	if (!header) return;

	gsap.to(header, {
		y: 0,
		duration: 0.4
	});

	header.classList.remove('scrolled', 'header--open-mob', 'text-white', 'text-black');
	header.classList.remove('header--open-mob');
}
export function setColorHeader() {
	const header = document.querySelector('.js-header');
	if (!header) return;
	const indicator	= document.querySelector('.js-header-color-indicator');

	if (indicator) {
		const className = indicator.dataset.class;
		
		if (className) {
			header.classList.add(className);
		}
	}
}
